var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFollowedCreatorsPlaceholderCreator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 61,
    viewBox: "0 0 65 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9056 0.48956C24.1003 0.982942 20.0189 3.12924 17.4616 7.12515C12.8797 14.2845 14.1085 19.9053 12.264 25.3236C10.4194 30.742 6.02001 32.244 2.60672 36.3212C-0.0575035 39.5036 -1.11735 47.6951 2.81243 52.1557C6.70294 56.5365 10.2889 60.5967 17.9698 60.0887C25.571 59.62 29.7782 54.8731 37.8 53.9496C45.8217 53.026 52.2366 55.0152 56.7471 51.6165C61.4769 48.0526 66.9605 37.5641 63.6782 29.3921C61.0381 22.819 53.4613 20.7668 50.1992 14.5401C46.937 8.31354 45.3549 5.53017 42.2348 3.84682C37.9215 1.51969 34.6494 0.0863899 29.9056 0.48956Z",
    fill: "#393939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 33C34.0711 33 35.75 31.3211 35.75 29.25C35.75 27.1789 34.0711 25.5 32 25.5C29.9289 25.5 28.25 27.1789 28.25 29.25C28.25 31.3211 29.9289 33 32 33Z",
    fill: "#90734F",
    fillOpacity: 0.24
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 33C34.0711 33 35.75 31.3211 35.75 29.25C35.75 27.1789 34.0711 25.5 32 25.5C29.9289 25.5 28.25 27.1789 28.25 29.25C28.25 31.3211 29.9289 33 32 33Z",
    stroke: "#CBA67A",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9844 36.6924C26.5487 35.5809 27.4097 34.6474 28.4721 33.9953C29.5344 33.3432 30.7566 32.998 32.0031 32.998C33.2496 32.998 34.4718 33.3432 35.5342 33.9953C36.5965 34.6474 37.4576 35.5809 38.0219 36.6924",
    stroke: "#CBA67A",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowedCreatorsPlaceholderCreator);
export default __webpack_public_path__ + "static/media/followed-creators-placeholder-creator.d3128ed3d0778fc043335ec4f918f9c2.svg";
export { ForwardRef as ReactComponent };